import React, { useState } from 'react'
import AddToCalendarModal from 'components_v1/addToCalendar/AddToCalendarModal'
import { useModal_deprecated } from 'hooks'

function useAddToCalendar() {
  const [selectedCardDetails, setSelectedCardDetails] = useState(null)
  const modal = useModal_deprecated()

  const handleAddToCalendarClick = (cardData) => {
    setSelectedCardDetails(cardData)
    modal.open()
  }

  const AddToCalendarDialog = (
    <AddToCalendarModal useModal={modal} classDetails={selectedCardDetails} />
  )

  return {
    handleAddToCalendarClick,
    AddToCalendarDialog
  }
}

export default useAddToCalendar
